module.exports = __webpack_public_path__ + "img/airflow.9313cbf7.png";